import { render, staticRenderFns } from "./StudentSupport.vue?vue&type=template&id=42748439&scoped=true&"
import script from "./StudentSupport.vue?vue&type=script&lang=js&"
export * from "./StudentSupport.vue?vue&type=script&lang=js&"
import style0 from "./StudentSupport.vue?vue&type=style&index=0&id=42748439&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42748439",
  null
  
)

export default component.exports